export default __webpack_public_path__ + "static/media/Raider's Helm of the Grasslands.48dcccbd.jpg";